import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {
  fetchCompany,
  saveCompany,
  formatCountriesForDisplay,
  formatCountryName,
  validatePartnerPublishState,
} from '../utils/companies';
import { useCompaniesStore, useLocationsStore } from '../oryx-state';
import CompanyView from './company-view';
import FetchStatus from '../utils/fetch-status';

const CompanyContainer = () => {
  const [fetchStatus, setFetchStatus] = useState(FetchStatus.FETCHING);
  const [showModal, setShowModal] = useState(false);
  const [infoModalState, setInfoModalState] = useState({
    published: false,
    firstName: false,
    statusEligible: false,
    error: '',
  });
  const [primaryLocations, setPrimaryLocations] = useState([]);
  const [secondaryLocations, setSecondaryLocations] = useState([]);
  const [countryName, setCountryName] = useState(null);

  const {
    companiesById,
    setCompanyById,
  } = useCompaniesStore();

  const { getCountryCodeToNameMap } = useLocationsStore();

  const { id } = useParams();

  useEffect(() => {
    fetchCompany(id)
      .then((res) => {
        setCompanyById(id, res);
        setFetchStatus(FetchStatus.SUCCESS);
      })
      .catch(() => {
        setFetchStatus(FetchStatus.ERROR);
      })
  }, [id, setCompanyById]);

  const company = companiesById[id];
  const countryCode = company?.offices && company.offices.length > 0 ? company.offices[0].country : null;

  useEffect(() => {
    if (company && getCountryCodeToNameMap) {
      // Get the country map once and reuse it
      getCountryCodeToNameMap().then((map) => {
        formatCountriesForDisplay(company.primaryCountries || [], map).then(setPrimaryLocations);
        formatCountriesForDisplay(company.secondaryCountries || [], map).then(setSecondaryLocations);
        
        if (countryCode) {
          setCountryName(formatCountryName(countryCode, map));
        } else {
          setCountryName(null);
        }
      });
    }
  }, [company?.primaryCountries, company?.secondaryCountries, countryCode, company, getCountryCodeToNameMap]);

  const openModal = () => {
    setShowModal((state) => !state);
  }

  const onClickSave = () => {
    const partner = companiesById[id];
    const updates = {
      description: partner.description,
      firstName: partner.firstName,
    };

    if (partner.photo) {
      updates.photo = partner.photo;
    }
    saveCompany(partner, updates)
      .then((res) => {
        if ('httpStatus' in res) throw new Error ('Error saving company');
        setCompanyById(id, res);
        const {
          firstName,
          statusEligible,
          published,
        } = validatePartnerPublishState(res);
        setInfoModalState({
          error: '',
          firstName,
          statusEligible,
          published,
        })
        setShowModal(true);
      })
      .catch((e) => {
        console.warn('error saving company');
        setInfoModalState({
          ...infoModalState,
          error: `There was an error saving company: ${companiesById[id].name}`
        })
      })
  }

  return (
    <CompanyView
      fetchStatus={fetchStatus}
      company={company}
      infoModalState={infoModalState}
      showModal={showModal}
      openModal={openModal}
      onClickSave={onClickSave}
      primaryLocations={primaryLocations}
      secondaryLocations={secondaryLocations}
      countryName={countryName}
    />
  );
};

export default CompanyContainer;
